import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Cookie } from 'lucide-react'

const STORAGE_KEY = 'plutonic_cookie_accepted'

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY)
    if (!accepted) setVisible(true)
  }, [])

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-3xl mx-auto bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={20} className="text-violet-400 mt-0.5 shrink-0" />
          <p className="text-sm text-gray-400 leading-relaxed">
            Utilizziamo solo <strong className="text-gray-300">cookie tecnici</strong> necessari al
            funzionamento della piattaforma (sessione di autenticazione). Nessun cookie di
            profilazione o tracciamento.{' '}
            <Link to="/privacy" className="text-violet-400 hover:text-violet-300 underline underline-offset-2 transition-colors">
              Privacy Policy
            </Link>
          </p>
        </div>
        <button
          onClick={accept}
          className="shrink-0 bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors whitespace-nowrap"
        >
          Ho capito
        </button>
      </div>
    </div>
  )
}

export default CookieBanner
